<template>
  <div>
    <el-input v-model="promoCodeValue" placeholder="Promo Code" @input="onInput" clearable>
      <el-button slot="append" @click="checkPromoCode" :disabled="!promoCodeValue" :loading="loading">Apply</el-button>
    </el-input>
    <el-tag type="success" v-if="couponDetailsFromState != null">
      {{ couponDetailsFromState.couponCode }} applied: {{ couponDetailsFromState.periodInDays }}-day trial activated.
    </el-tag>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "PromoCodeInput",
  props: {
    value: { // for v-model
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      promoCodeValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.promoCodeValue = newValue;
    }
  },
  computed: {
    ...mapState({couponDetailsFromState: state => state.uConnect.couponDetails})
  },
  methods: {
    ...mapActions("uConnect", ["applyCouponCode"]),
    onInput() {
      this.$emit("input", this.promoCodeValue);
      this.$emit("validated", false); // reset validation
    },
    checkPromoCode() {
      this.loading = true;
      const uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
      if(!uConnectRegistrationKey) {
          this.$message.error("Registration key not found. Please restart the process.");
          this.loading = false;
          this.$emit("validated", false);
          return;
      }
      const params = {
        userId: this.$store.state.uConnect.userId,
        email: this.$store.state.uConnect.email,
        couponCode: this.promoCodeValue,
        uConnectRegistrationKey: uConnectRegistrationKey
      };
      this.applyCouponCode({
        params,
        callback: res => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success("Promo code applied successfully!");
            this.$store.commit("uConnect/updateCouponDetails", {couponDetails: res.data.data});
            this.$emit("validated", true);
          } else {
            this.$message.error(res.data.data || "Invalid promo code.");
            this.$emit("validated", false);
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/promoCodeInput.vue